import { map } from 'lodash';

export default function getSerializedFilterId(params, validParams) {
  return map(validParams, paramKey => {
    return params[paramKey] ? `${paramKey}-${params[paramKey]}` : `${paramKey}-null`;
  }).join('&&');
}
